import Box from '@material-ui/core/Box';
import { VALUE_CONVERSION_MODE_ONLY_WITHOUT } from '../ToggleFilter';
import {
  SEARCH_BY_ORGANIZATION_OR_DOCTOR,
  SEARCH_BY_PATIENT,
  SEARCH_BY_TRACKING_NUMBER
} from './default';

/**
 * Patients page layout while the "Retainers" request type is selected.
 * Retainers are always handled by OrthoSelect and have no tech workflow, hold,
 * rush or batching, so those controls are omitted rather than disabled.
 */
export default [
  {
    gridItem: { xs: 12, md: 4 },
    ...SEARCH_BY_PATIENT
  },
  {
    ...SEARCH_BY_ORGANIZATION_OR_DOCTOR,
    gridItem: { xs: 12, md: 4 }
  },
  {
    ...SEARCH_BY_TRACKING_NUMBER,
    gridItem: { xs: 12, md: 4 }
  },
  {
    type: 'group',
    name: 'request_group',
    gridItem: { xs: 12 },
    containerProps: { spacing: 2, alignItems: 'flex-end' },
    items: [
      {
        type: 'request_filters',
        name: 'request',
        withAssignmentFilter: false,
        fieldSizes: { request: { xs: 12, md: 4 }, status: { xs: 12, md: 4 } }
      },
      { type: 'shipping_date', name: 'shipping_date', stacked: true, gridItem: { xs: 12, md: 4 } }
    ]
  },
  {
    type: 'group_inline',
    name: 'group_b',
    gridItem: { xs: 12 },
    ContainerComponent: Box,
    containerProps: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    items: [
      {
        type: 'toggle',
        name: 'activeRequestOnly',
        nullable: true,
        label: 'Active Only'
      },
      {
        type: 'toggle',
        name: 'shipping',
        nullable: true
      },
      {
        type: 'toggle',
        name: 'archived',
        label: 'Archived Only',
        valueConversionMode: VALUE_CONVERSION_MODE_ONLY_WITHOUT
      },
      {
        type: 'toggle',
        name: 'caseNotesOnly',
        label: 'With Case Notes Only'
      },
      {
        type: 'sorting'
      }
    ]
  },
  {
    type: 'group_inline',
    name: 'group_c',
    items: [
      {
        type: 'item',
        name: 'collapse'
      },
      {
        type: 'item',
        name: 'auto-refresh'
      },
      {
        type: 'item',
        name: 'onhold'
      },
      {
        type: 'item',
        name: 'reset_filters'
      }
    ]
  }
];
